import type { AccountCampaign } from '../../types/accountCampaign';

// Meta grid header counters (Item 6; OrganicAssets spec §5.2). Pure so the
// semantics are unit-tested without the grid.
//
// The caller passes the master rows query result, which the service already
// filters to deletedAt == null, so we only drop rowType === 'opt_out' here.
// Not platform-filtered (a simple "campaigns in this rollout" tally).
//
//   - Main Built:             built / total   (UI label "Main Built")
//       total = non-opt-out rows
//       built = those with metaBuilt === true
//
//   - Local Campaign Builds:  localBuilt / localTotal
//       localTotal = non-opt-out rows whose Local folder HAS FILES
//                    (hasLocalFiles === true — file presence, not merely a
//                    configured URL; OrganicAssets spec §5.2)
//       localBuilt = of those, rows the buyer ticked metaLocalBuilt
//
//   - Organic Campaign Builds: organicBuilt / organicTotal
//       organicTotal = non-opt-out rows whose Organic folder HAS FILES
//       organicBuilt = of those, rows the buyer ticked metaOrganicBuilt
//
// "Of the rows that have FILES in the folder, how many has the buyer marked as
// built?" A row marked built but with no files is excluded from BOTH tallies
// (preserves the "of rows with assets" framing). hasLocalFiles /
// hasOrganicFiles are optional/undefined on legacy rows → treated as "no
// files" until the first folder refresh (C11) populates them.
export type MetaBuildCounters = {
  total: number;
  built: number;
  localTotal: number;
  localBuilt: number;
  organicTotal: number;
  organicBuilt: number;
};

export function computeMetaBuildCounters(
  masterRows: readonly AccountCampaign[],
): MetaBuildCounters {
  let total = 0;
  let built = 0;
  let localTotal = 0;
  let localBuilt = 0;
  let organicTotal = 0;
  let organicBuilt = 0;
  for (const r of masterRows) {
    if (r.rowType === 'opt_out') continue;
    total += 1;
    if (r.metaBuilt === true) built += 1;
    if (r.hasLocalFiles === true) {
      localTotal += 1;
      if (r.metaLocalBuilt === true) localBuilt += 1;
    }
    if (r.hasOrganicFiles === true) {
      organicTotal += 1;
      if (r.metaOrganicBuilt === true) organicBuilt += 1;
    }
  }
  return { total, built, localTotal, localBuilt, organicTotal, organicBuilt };
}
